import React, { useState, useContext } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import FeatureDisabledTooltip from "./featureDisabledTooltip";
import { Link } from "react-router-dom";
import { StateContext } from "../utils/context";
import { useTranslation } from "react-i18next";

const SubscriptionTableDropdown = ({
  data,
  setSuccess,
  setError,
  setToggleModal,
  setToggleModalResume,
  setToggleModalRetryPayment,
  setDataModal,
  setLastAction
}) => {
  const { t } = useTranslation();
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);

  const {currentUser} = useContext(StateContext);
  
  const statusUpdateBtnText = (data.cancel_at_period_end) ? t("subscription.view.table.actionDropdown.button.enableAutoRenewal") : t("subscription.view.table.actionDropdown.button.cancelSubscription");
  const statusUpdateAction = (data.cancel_at_period_end) ? t("subscription.view.table.actionDropdown.message.successSubscripionAutoRenewalEnabled") : t("subscription.view.table.actionDropdown.message.successSubscripionCancelled");

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret outline color="primary">
        {t("subscription.view.table.actionDropdown.label.action")}
      </DropdownToggle>

      <DropdownMenu>        
        {
          (data.status === "active") &&
          <>
            <DropdownItem
              onClick={() => {
                setSuccess(false);
                setError(false);
                setDataModal(data);
                setToggleModal(true);
                setLastAction(statusUpdateAction);
              }}
              style={{ cursor: "pointer" }}
            >
              {statusUpdateBtnText}
            </DropdownItem>
            <DropdownItem>
              <Link to={`/subscription/upgrade/`}>{t("subscription.view.table.actionDropdown.button.upgradeSubscription")}</Link>
            </DropdownItem>
          </>
        }
        
        {
          (data.status === "canceled") &&
          <>
            <DropdownItem
              id={`fdc-${data.id}`}
              disabled={currentUser && (currentUser.subscription_active || currentUser.has_incomplete_subscription)}
              onClick={() => {
                setSuccess(false);
                setError(false);
                setDataModal(data);
                setToggleModalResume(true);
                setLastAction(t("subscription.view.table.actionDropdown.message.successSubscripionResumed"));
              }}
              style={{ cursor: "pointer" }}
            >
              {t("subscription.view.table.actionDropdown.button.resumeSubscription")}
            </DropdownItem>
            {
              (currentUser && currentUser.subscription_active) && <FeatureDisabledTooltip target={`fdc-${data.id}`} msg={t("subscription.view.table.actionDropdown.message.activeSubscription")} />
            }
            {
              (currentUser && !currentUser.subscription_active && currentUser.has_incomplete_subscription) && <FeatureDisabledTooltip target={`fdc-${data.id}`} msg={t("subscription.view.table.actionDropdown.message.incompleteSubscription")} />
            }
          </>
        }

        {
          (data.status === "incomplete") &&
          <>
            <DropdownItem
              id={`fdi-${data.id}`}
              disabled={currentUser && currentUser.subscription_active}
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSuccess(false);
                setError(false);
                setDataModal(data);
                setToggleModalRetryPayment(true);
                setLastAction(t("subscription.view.table.actionDropdown.message.successSubscripionResumed"));
              }}
            >
              {t("subscription.view.table.actionDropdown.button.retryPayment")}
            </DropdownItem>
            {
              (currentUser && currentUser.subscription_active) && <FeatureDisabledTooltip target={`fdi-${data.id}`} msg={t("subscription.view.table.actionDropdown.message.activeSubscription")} />
            }
          </>
        }
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default SubscriptionTableDropdown;